// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.edit-custom-select[data-v-ee2c067c]{\n    display: block;\n    position: absolute;\n    right: 5px;\n    z-index: 9;\n    top: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
